export enum DriverCertificateType {
  DriverLicense = "DriverLicense",
  Insurance = "Insurance",
  Id = "Id",
  Vehicle = "Vehicle"
}

export enum DriverCertificateName {
  DriverLicense = "driverLicense",
  Insurance = "insurance",
  Id = "idLicense",
  Vehicle = "vehicle"
}

export const DRIVER_CERTIFICATES_LIST = [
  {
    label: "Driver License",
    value: DriverCertificateType.DriverLicense,
    name: DriverCertificateName.DriverLicense
  },
  {
    label: "Insurance",
    value: DriverCertificateType.Insurance,
    name: DriverCertificateName.Insurance
  },
  {
    label: "ID",
    value: DriverCertificateType.Id,
    name: DriverCertificateName.Id
  },
  {
    label: "Vehicle",
    value: DriverCertificateType.Vehicle,
    name: DriverCertificateName.Vehicle
  }
];
